import { axiosInstance } from '@libs/axios/axios';
import { apiCall } from '@shared/entity';
import { PaymentQr, QrPaymentType, ReceivedPayment, SyncReceivedPaymentsResult } from './entity';

export const receivedPaymentsApi = {
  getAll: () => '/api/received-payments',
  sync: () => '/api/received-payments/sync',
  visitQr: (visitId: string, type: QrPaymentType) =>
    `/api/visits/${encodeURIComponent(visitId)}/payment-qr?type=${type}`,
  createPending: () => '/api/received-payments/pending',
  deletePending: (visitId: string, type: QrPaymentType) =>
    `/api/received-payments/pending/${encodeURIComponent(visitId)}?type=${type}`,
  confirmPending: (visitId: string, type: QrPaymentType) =>
    `/api/received-payments/pending/${encodeURIComponent(visitId)}/confirm?type=${type}`,
};

export const getReceivedPayments = async (): Promise<ReceivedPayment[]> =>
  apiCall(
    async () => await axiosInstance.get(receivedPaymentsApi.getAll()),
    'api.receivedPayments.notFound',
  );

export const postSyncReceivedPayments = async (): Promise<SyncReceivedPaymentsResult> =>
  apiCall(
    async () => await axiosInstance.post(receivedPaymentsApi.sync()),
    'api.receivedPayments.syncError',
  );

export const getVisitPaymentQr = async (visitId: string, type: QrPaymentType): Promise<PaymentQr> =>
  apiCall(
    async () => await axiosInstance.get(receivedPaymentsApi.visitQr(visitId, type)),
    'api.receivedPayments.qrError',
  );

export const postCreatePendingPayment = async (
  visitId: string,
  type: QrPaymentType,
): Promise<ReceivedPayment> =>
  apiCall(
    async () => await axiosInstance.post(receivedPaymentsApi.createPending(), { visitId, type }),
    'api.receivedPayments.pendingError',
  );

export const deleteDeletePendingPayment = async (
  visitId: string,
  type: QrPaymentType,
): Promise<void> =>
  apiCall(
    async () => await axiosInstance.delete(receivedPaymentsApi.deletePending(visitId, type)),
    'api.receivedPayments.pendingDeleteError',
  );

export const postConfirmPendingPayment = async (
  visitId: string,
  type: QrPaymentType,
): Promise<void> =>
  apiCall(
    async () => await axiosInstance.post(receivedPaymentsApi.confirmPending(visitId, type)),
    'api.receivedPayments.pendingConfirmError',
  );
